exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".datos-tramite{margin-top:30px}.datos-tramite ul{padding-left:0}.datos-tramite li{list-style-type:none}@page{size:A4}@media print{.btn,.main-footer,.panel-pane{display:none}}", "", {"version":3,"sources":["/opt/snt/front-end-turnos/src/app/turnos/shared/datos-turno/datos-turno.component.scss"],"names":[],"mappings":"AAAA,eACE,eAAgB,CADlB,kBAII,cAAe,CAJnB,kBAQI,oBAAqB,CACtB,MAGD,OAAQ,CAAA,aAGR,8BAGE,YAAa,CACd,CAAA","file":"datos-turno.component.scss","sourcesContent":[".datos-tramite {\r\n  margin-top: 30px;\r\n\r\n  ul {\r\n    padding-left: 0;\r\n  }\r\n\r\n  li {\r\n    list-style-type: none;\r\n  }\r\n}\r\n@page {\r\n  size: A4;\r\n}\r\n@media print {\r\n  .btn,\r\n  .main-footer,\r\n  .panel-pane {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/snt/front-end-turnos/src/app/turnos/shared/datos-turno/datos-turno.component.scss
// module id = QkYP
// module chunks = 2